import { IFieldResponseData } from "../fields/types";
import { IError } from "../types/errors";
import { ActionType } from "../types/store-types";

/* - Data Types - */

interface ISubPlans {
    [key: string]: any; // NEEDS TO BE CHANGED AFTER CORRECT DATA GET
}
export interface IPayments {
    isError: boolean;
    isShowPromocodeField: boolean;
    isShowPaymentTypeField: boolean;
    subscriptionPlans?: ISubPlans;
}

export enum PaymentTypeEnum {
    ONE_TIME = 1,
    SUBSCRIPTION,
    DONATION,
}
export enum PaymentMethodEnum {
    STRIPE,
    PAYPAL,
    CASH,
    SQUARE,
}
interface IPaymentReceipt {
    name: string;
    email: string;
    phone: string;
    address: string;
    enabled: boolean;
    template?: string;
}
export interface IPaymentsMethods {
    stripe: boolean;
    paypal: boolean;
    square: boolean;
    cash: boolean;
}

export enum PromocodeDiscountTypeEnum {
    percent = 1,
    fixed,
}
export enum PromocodeLimitTypeEnum {
    date = 1,
    quantity,
    noLimit,
}
export enum PromocodeApplyToTypeEnum {
    field = 1,
    form,
}

export interface IPromocodeApplyToField {
    field?: string;
    options?: string[];
}

export interface IPromoCode {
    _id?: string;
    isActive: boolean;
    payment: string;
    code: string;
    discountType: PromocodeDiscountTypeEnum;
    discount: number | string;
    limitType: PromocodeLimitTypeEnum;
    limitDate: string;
    limitCount: number | string;
    applyTo: PromocodeApplyToTypeEnum;
    field?: IPromocodeApplyToField[];
}

export interface IPaymentsData {
    paymentID: string;
    paymentType: PaymentTypeEnum;
    account: {
        stripe: any;
        square: any;
        paypal: {
            email: string;
        };
    };
    paymentMethod: IPaymentsMethods;
    fee: number;
    shippingFee: number;
    showTotal: boolean;
    enablePromocode: boolean;
    redirectUrl?: string;
    paymentReceipt: IPaymentReceipt;
    promocodes: IPromoCode[];
    payableFields: {
        ONE_TIME: string[];
        SUBSCRIPTION: string[];
    };
}

interface IAuthPayPalUser {
    email: string;
    formId: string;
}

interface IAuthStripeUserRequest {}
interface IAuthSquareUserRequest {}
interface IConfirmStripeAuthRequest {
    queries: string;
}

interface IUpdatePaymentRequest {
    data: any;
    paymentID: string;
}

interface IDisconnectPaymentMethod {
    type: PaymentMethodEnum;
}

interface IActivatePaymentCash {}

export interface ICreatePromoCode {
    allPromoCodes: IPromoCode[];
    isActive: boolean;
    payment: string;
    code: string;
    discountType: PromocodeDiscountTypeEnum;
    discount: number | string;
    limitType: PromocodeLimitTypeEnum;
    limitDate: string;
    limitCount: number | string;
    applyTo: PromocodeApplyToTypeEnum;
    field?: IPromocodeApplyToField[];
    _id?: string;
}

interface IUpdatePromoCode {
    index: number | null;
    promoList: IPromoCode[];
    prevState: IPromoCode;
    currentState: IPromoCode;
}

interface IDuplicatePromoCode {
    promoList: IPromoCode[];
    promoCodeId: string;
}
interface IDeletePromoCode {
    promoCodeId: string;
}

interface IChangeIsFormHavePromoCodeField {
    value: boolean;
}
interface IChangeIsFormHavePaymentTypeField {
    value: boolean;
}

interface IInitPaymentFields {
    list: IFieldResponseData[];
    paymentSettings: IPaymentsData;
}

interface IInitPaymentData {
    [key: string]: any;
}

interface IGetSquareSubPlansRequest {
    settingsId: string;
}
interface IGetSquareSubPlansSuccess {
    data: ISubPlans;
}
interface IGetSquareSubPlansFailure extends IError {}
/* - Action Types - */

export enum PaymentActionTypes {
    INIT_PAYABLE_FIELDS = "PAYMENT.INIT_PAYABLE_FIELDS",
    INIT_PAYMENT_DATA = "PAYMENT.INIT_PAYMENT_DATA",
    UPDATE_PAYMENT_REQUEST = "PAYMENT.UPDATE_PAYMENT_REQUEST",
    AUTH_PAYPAL_USER_REQUEST = "PAYMENT.AUTH_PAYPAL_USER",
    AUTH_SQUARE_USER_REQUEST = "PAYMENT.AUTH_SQUAREL_USER",
    AUTH_STRIPE_USER_REQUEST = "PAYMENT.AUTH_STRIPE_USER_REQUEST",
    CONFIRM_STRIPE_AUTH_REQUEST = "PAYMENT.CONFIRM_STRIPE_AUTH_REQUEST",
    ACTIVATE_PAYMENT_METHOD_CASH = "PAYMENT.ACTIVATE_PAYMENT_METHOD_CASH",
    DISCONNECT_PAYMENT_METHOD = "PAYMENT.DISCONNECT_PAYMENT_METHOD",
    CREATE_PROMOCODE = "PAYMENT.CREATE_PROMOCODE",
    UPDATE_PROMOCODE = "PAYMENT.UPDATE_PROMOCODE",
    DUPLICATE_PROMOCODE = "PAYMENT.DUPLICATE_PROMOCODE",
    DELETE_PROMOCODE = "PAYMENT.DELETE_PROMOCODE",
    CHANGE_IS_SHOW_PROMOCODE_FIELD = "PAYMENT.CHANGE_IS_SHOW_PROMOCODE_FIELD",
    CHANGE_IS_SHOW_PAYMENT_TYPE_FIELD = "PAYMENT.CHANGE_IS_SHOW_PAYMENT_TYPE_FIELD",

    GET_SQUARE_SUBSCRIPTIONS_REQUEST = "PATMENT.GET_SQUARE_SUBSCRIPTIONS_REQUEST",
    GET_SQUARE_SUBSCRIPTIONS_SUCCESS = "PATMENT.GET_SQUARE_SUBSCRIPTIONS_SUCCESS",
    GET_SQUARE_SUBSCRIPTIONS_FAILURE = "PATMENT.GET_SQUARE_SUBSCRIPTIONS_FAILURE",
}

/* - Action Interfaces  - */

export type InitPayableFieldsActionType = ActionType<PaymentActionTypes.INIT_PAYABLE_FIELDS, IInitPaymentFields>;
export type InitPaymentDataActionType = ActionType<PaymentActionTypes.INIT_PAYMENT_DATA, IInitPaymentData>;
export type UpdatePaymentRequestActionType = ActionType<
    PaymentActionTypes.UPDATE_PAYMENT_REQUEST,
    IUpdatePaymentRequest
>;

export type AuthPayPalUserRequestActionType = ActionType<PaymentActionTypes.AUTH_PAYPAL_USER_REQUEST, IAuthPayPalUser>;

export type AuthStripeUserRequestActionType = ActionType<
    PaymentActionTypes.AUTH_STRIPE_USER_REQUEST,
    IAuthStripeUserRequest
>;

export type AuthSquareUserRequestActionType = ActionType<
    PaymentActionTypes.AUTH_SQUARE_USER_REQUEST,
    IAuthSquareUserRequest
>;

export type GetSquareSubsRequestActionType = ActionType<
    PaymentActionTypes.GET_SQUARE_SUBSCRIPTIONS_REQUEST,
    IGetSquareSubPlansRequest
>;

export type GetSquareSubsSuccessActionType = ActionType<
    PaymentActionTypes.GET_SQUARE_SUBSCRIPTIONS_SUCCESS,
    IGetSquareSubPlansSuccess
>;

export type GetSquareSubsFailureActionType = ActionType<
    PaymentActionTypes.GET_SQUARE_SUBSCRIPTIONS_FAILURE,
    IGetSquareSubPlansFailure
>;

export type ConfirmStripeAuthRequestActionType = ActionType<
    PaymentActionTypes.CONFIRM_STRIPE_AUTH_REQUEST,
    IConfirmStripeAuthRequest
>;

export type DisconnectPaymentMethodActionType = ActionType<
    PaymentActionTypes.DISCONNECT_PAYMENT_METHOD,
    IDisconnectPaymentMethod
>;
export type ActivatePaymentMethodCashActionType = ActionType<
    PaymentActionTypes.ACTIVATE_PAYMENT_METHOD_CASH,
    IActivatePaymentCash
>;
export type CreatePromoCodeActionType = ActionType<PaymentActionTypes.CREATE_PROMOCODE, ICreatePromoCode>;
export type UpdatePromoCodeActionType = ActionType<PaymentActionTypes.UPDATE_PROMOCODE, IUpdatePromoCode>;

export type DuplicatePromoCodeActionType = ActionType<PaymentActionTypes.DUPLICATE_PROMOCODE, IDuplicatePromoCode>;
export type DeletePromoCodeActionType = ActionType<PaymentActionTypes.DELETE_PROMOCODE, IDeletePromoCode>;

export type ChangeIsShowPromoCodeFieldActionType = ActionType<
    PaymentActionTypes.CHANGE_IS_SHOW_PROMOCODE_FIELD,
    IChangeIsFormHavePromoCodeField
>;
export type ChangeIsShowPaymentTypeFieldActionType = ActionType<
    PaymentActionTypes.CHANGE_IS_SHOW_PAYMENT_TYPE_FIELD,
    IChangeIsFormHavePaymentTypeField
>;
